import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft, Save } from "react-feather";
import ToastNotification from "Components/UI/ToastNotification";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useUpdateUserGroupMutation } from "AppQuries/user/user-group";
import { userMasterValidation } from "core/Operations/ValidationSchema/userValidationSchema";
import UserMasterForm from "Components/Form/UserMasterForm";
import { getCurrentFormattedDate } from "core/Operations/currentDateTime";
import {
  useGetUserMasterByIdQuery,
  useUpdateUserMasterMutation,
} from "AppQuries/user/user-master";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { toast } from "core/Operations/toast";
const EditUserMaster = () => {
  const userData = useSelector(loggedInUser);
  const { code } = useParams();
  const {
    data: userMasterData,
    isLoading,
    isError: isFetchingError,
    error: fetchingError,
  } = useGetUserMasterByIdQuery({
    companyCode: userData?.companyCode,
    code: code,
  });
  const {
    mutate: editUserMaster,
    isPending,
    isError,
    error,
  } = useUpdateUserMasterMutation();

  const methods = useForm({
    defaultValues: {
      companyCode: userData?.companyCode,
      modifyUser: userData?.userName,
      modifyDate: getCurrentFormattedDate(),
      lastLoginLocation: "",
    },
    resolver: yupResolver(userMasterValidation),
  });

  const navigate = useNavigate();

  const {
    setValue,
    handleSubmit,
    formState: { errors },
  } = methods;
  console.log("errors", errors);

  const onSubmit = (payload) => {
    console.log(payload);

    payload.lastLoginLocation = "";

    editUserMaster(payload, {
      onSuccess: (data) => {
        
        if (data.response === true) {
          toast.success(data.errorMessage || "User Master Updated Successfully.");
          // setTimeout(() => {
            navigate(`${all_routes.user_master}${all_routes.user_master_list}`);
          // }, 1000);
        } else {
          toast.warning(data.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };
  useEffect(() => {
    console.log(userMasterData);
    if (Array.isArray(userMasterData) && userMasterData.length > 0) {
      Object.keys(userMasterData[0]).forEach((key) => {
        setValue(key, userMasterData[0][key]);
      });
    }
  }, [userMasterData]);

  if (isError) return <Error404 error={error} />;
  if (isFetchingError) return <Error404 error={fetchingError} />;
  if (isLoading || isPending) return <LoadingSpinner />;
  return (
    <div>
      <div className="page-wrapper">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="content">
              <div className="page-header">
                <div className="add-item d-flex">
                  <div className="page-title">
                    <h4>Update User Master</h4>
                    <h6>Edit User Master </h6>
                  </div>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
                  >
                    <Link
                      to={`${all_routes.user_master}${all_routes.user_master_list}`}
                      className="btn btn-secondary"
                    >
                      {/* <ArrowLeft className="me-2" /> */}
                      Back
                    </Link>
                  </OverlayTrigger>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">Update User Master</Tooltip>
                    }
                  >
                    <button type="submit" className="btn btn-added">
                      <Save className="me-2" />
                      Update
                    </button>
                  </OverlayTrigger>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card border-0">
                    <div className="card-header">
                      <h4 className="card-title">Update User Master</h4>
                    </div>
                    <div className="card-body">
                      <UserMasterForm />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default EditUserMaster;
